import { Analytics } from '@cld/unicorn-api';
import { Action } from '../actions';

export const analyticsMiddleware = (_: Analytics, action: Action) => {
  switch (action.type) {
    default:
  }
};
